import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportWorkOrder } from './WorkOrder.services';

export function useQuestReportWorkOrder() {
  return useMutation(getQuestReportWorkOrder, {
    onSuccess() {
      notification.success({
        message: 'O relatório de orçamento foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
